import { EyeOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Col, Row, Tooltip } from 'antd';
import moment from 'moment';
import { Text, Box } from 'atoms';
import { StatusAction } from 'components';
import { ACL } from 'components/common';
import { getLocalDate, getLocalTime } from 'utils/helpers';
import { DAY_DATE_FORMAT } from 'utils/config';
import { getVCF } from 'store/vendorBillSlice';

const dateFormat = 'MM/DD/YYYY';
const pdf = 'pdf';
const docx = 'docx';

export const VendorContractTableConfig = [
	{
		title: 'Vendor Name',
		dataIndex: 'vendor_name',
		key: 'vendor_name',
		hidden: false,
		render: (vendor_name) => <Text overFlow="hidden">{vendor_name || ''}</Text>,
	},
	{
		title: 'Vehicle Type ',
		dataIndex: 'vehicle_type',
		key: 'vehicle_type',
		hidden: false,
		render: (vehicle_type) => <Text overFlow="hidden">{vehicle_type || ''}</Text>,
	},
	{
		title: 'Client',
		dataIndex: 'client_name',
		key: 'client_name',
		hidden: false,
		render: (client_name) => <Text overFlow="hidden">{client_name || ''}</Text>,
	},
	{
		title: 'Project Location',
		dataIndex: 'project_location_code',
		key: 'project_location_code',
		hidden: false,
		render: (project_location_code) => (
			<Text overFlow="hidden">{project_location_code || ''}</Text>
		),
	},
	{
		title: 'City',
		dataIndex: 'city',
		key: 'city',
		hidden: false,
		render: (city) => <Text overFlow="hidden">{city || ''}</Text>,
	},
	{
		title: 'Contract Date',
		dataIndex: 'contract_date',
		key: 'contract_date',
		hidden: false,
		render: (contract_date) => (
			<Text overFlow="hidden">
				{moment(contract_date, dateFormat).format(DAY_DATE_FORMAT) || ''}
			</Text>
		),
	},
	{
		title: 'Expiry Date',
		dataIndex: 'expiry_date',
		key: 'expiry_date',
		hidden: false,
		render: (expiry_date) => (
			<Text overFlow="hidden">
				{moment(expiry_date, dateFormat).format(DAY_DATE_FORMAT) || ''}
			</Text>
		),
	},
	{
		title: 'Created at',
		dataIndex: 'created_at',
		key: 'created_at',
		hidden: false,
		render: (created_at) => (
			<Box>
				<Text overFlow="hidden">{getLocalDate(created_at)}</Text>

				<Text overFlow="hidden" fontStyle="italic">
					{getLocalTime(created_at)}
				</Text>
			</Box>
		),
	},
	{
		title: 'VCF',
		dataIndex: 'id',
		key: 'id',
		width: '8%',
		hidden: false,
		render: (id) => (
			<Row gutter={16}>
				<Col>
					<Col>
						<Tooltip title="Download VCF">
							<FilePdfOutlined
								style={{
									color: 'red',
									fontSize: '14px',
								}}
								onClick={getVCF({ id, type: pdf })}
							/>
						</Tooltip>
					</Col>
				</Col>
				<Col>
					<Tooltip title="Download DOC">
						<FilePdfOutlined
							style={{
								color: 'blue',
								fontSize: '14px',
							}}
							onClick={getVCF({ id, type: docx })}
						/>
					</Tooltip>
				</Col>
			</Row>
		),
	},
	{
		title: 'View',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id) => (
			<Link to={`/vendor-contracts/${id}`}>
				<EyeOutlined />
			</Link>
		),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id, record) => (
			<ACL action="update" module="vendor_contract">
				<StatusAction statusData={record?.is_active} userType="vendor_contract" id={id} />
			</ACL>
		),
	},
];
